import { useCallback, useState } from 'react';

import { ForgotModalContainer } from 'apps/auth/scripts/containers';
import { LoginModalContainer } from 'apps/auth/scripts/containers/LoginContainer';
import { SignupModalContainer } from 'apps/auth/scripts/containers/SignupContainer';

import AuthPrompt from './AuthPrompt';
import { AuthStep } from './constants';

interface Props {
  onBack: () => void;
  onCancel: () => void;
  onComplete: () => void;
  onSkip: () => void;
}

const CardAuth = ({ onBack, onCancel, onComplete, onSkip }: Props) => {
  const [step, setStep] = useState<AuthStep>(AuthStep.Unset);

  const onForgot = useCallback(() => {
    setStep(AuthStep.Forgot);
  }, []);

  const onLogin = useCallback(() => {
    setStep(AuthStep.Login);
  }, []);

  const onSignup = useCallback(() => {
    setStep(AuthStep.Signup);
  }, []);

  const onDefault = useCallback(() => {
    setStep(AuthStep.Unset);
  }, []);

  switch (step) {
    case AuthStep.Login:
      return (
        <LoginModalContainer
          onBack={onDefault}
          onCancel={onCancel}
          onComplete={onComplete}
          onForgot={onForgot}
          onSignup={onSignup}
        />
      );
    case AuthStep.Signup:
      return (
        <SignupModalContainer
          onBack={onDefault}
          onCancel={onCancel}
          onComplete={onComplete}
          onLogin={onLogin}
        />
      );
    case AuthStep.Forgot:
      return <ForgotModalContainer onCancel={onCancel} onLogin={onLogin} />;
    default:
      return (
        <AuthPrompt
          onBack={onBack}
          onCancel={onCancel}
          onGuest={onSkip}
          onJoin={onSignup}
          onLogin={onLogin}
        />
      );
  }
};

CardAuth.displayName = 'CardAuth';

export default CardAuth;
